import { ApiDate } from '../realty/model/ApiDate';

export function defined(...args: any[]): boolean {
  for (let i = 0; i < args.length; ++i) {
    if (args[i] === undefined) {
      return false;
    }
  }
  return true;
}

export function firstDatePrecedesSecond(d0: ApiDate, d1: ApiDate): boolean {
  const date0Components = d0.timestamp.split('-');
  const date1Components = d1.timestamp.split('-');
  let difference = 0;
  for (let i = 0; i < date0Components.length && difference === 0; ++i) {
    difference = parseInt(date0Components[i], 10) - parseInt(date1Components[i], 10);
  }
  return difference < 0;
}

export function equal(t0: any, t1: any): boolean {
  const propertyNames: string[] = Object.getOwnPropertyNames(t0);
  for (let i = 0; i < propertyNames.length; ++i) {
    if (t0[propertyNames[i]] !== t1[propertyNames[i]]) {
      return false;
    }
  }
  return true;
}

export function evaluate(object: any, property?: string): any {
  const propertyComponents = defined(property) ? property.split('.') : [];
  for (let i = 0; i < propertyComponents.length && defined(object); ++i) {
    object = object[propertyComponents[i]];
  }
  return object;
}



/** WEBPACK FOOTER **
 ** ./src/utility/Control.ts
 **/